import { render } from "./FormLayout.vue?vue&type=template&id=0db500b8"
import script from "./FormLayout.vue?vue&type=script&lang=js"
export * from "./FormLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__